module.exports = __webpack_public_path__ + "files/0daa088e470a7dafd6f8eb61537a7b01.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-4.png
// module id = 503
// module chunks = 76